import $ from 'jquery'
class HeaderScroll {
  constructor(element) {
    if (!element) {
      return false
    }

    this.header = jQuery(element)

    this.timeout = 0
    this.didScroll
    this.lastScrollTop = 0
    this.navbarHeight = this.header.outerHeight()
    this.delta = this.navbarHeight / 2

    this._hasScrolled()

    $(window).on('scroll', () => {
      //clearTimeout(this.timeout)
      this.didScroll = true

      this._hasScrolled()

      setTimeout(() => {
        if (this.didScroll) {
          this._directionScrolled()
          this.didScroll = false
        }
      }, 250)
    })
    
  }

  _hasScrolled() {
    var st = $(window).scrollTop()

    if (st > 10) {
      this.header.addClass('header--scrolled')
    } else {
      this.header.removeClass('header--scrolled')
    }
  }

  _directionScrolled() {
    var st = $(window).scrollTop()

    // Make sure they scroll more than delta
    if (Math.abs(this.lastScrollTop - st) <= this.delta) return

    if (st > this.lastScrollTop && st > this.navbarHeight) {
      this.header.removeClass('scrolled-up').addClass('scrolled-down')
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        this.header.removeClass('scrolled-down').addClass('scrolled-up')
      }
    }
    this.lastScrollTop = st
  }
}
export default HeaderScroll
